
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.25 24a1 1 0 001-1v-8.75H23a1 1 0 001-1v-2.5a1 1 0 00-1-1h-8.75V1a1 1 0 00-1-1h-2.5a1 1 0 00-1 1v8.75H1a1 1 0 00-1 1v2.5a1 1 0 001 1h8.75V23a1 1 0 001 1h2.5z","fill":"#4F9BF3"}})])
          )
        }
      }
    